import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import FooterPanel from './../../FooterPanel';
import EventsHeroPanel from "./EventsHeroPanel";
import EventsPanel from "../../EventsPanel";
import EventPanel from "../../EventPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    }
});

class EventsPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
        jsonEvents: []
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'events'} />
              <EventsHeroPanel />
              <EventsPanel />
              <EventPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(EventsPage)
